export default "__VITE_ASSET__CwvSFbG5__"